import "./App.css";
import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Layout from "./Components/Shared/Layout/Layout";
import ErrorBoundary from "./Components/ErrorBoundary";
import SocialIcon from "./Components/utils/SocialIcon/SocialIcon";
import BackgroundLine from "./Components/utils/BackgroundLine/BackgroundLine";
import FairyDustCursor from "./Components/utils/FairyDustCursor/FairyDustCursor";

function App() {
  /* const getInitialTheme = () => {
    const savedTheme = localStorage.getItem("theme");

    if (savedTheme === null) {
      return true;
    }
    try {
      return JSON.parse(savedTheme);
    } catch {
      return true;
    }
  };

  const [isDarkMode, setIsDarkMode] = useState(getInitialTheme);

  const toggleTheme = () => {
    setIsDarkMode((prevMode) => !prevMode);
  }; */

  /*  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("theme", JSON.stringify(isDarkMode)); 
  }, [isDarkMode]); */

  useEffect(() => {
    // SEO: Add structured data for better search engine understanding
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Person",
      "name": "Md Ashraful Islam",
      "jobTitle": "Lead Frontend & Full-Stack Engineer",
      "url": process.env.REACT_APP_SITE_URL || "https://ashrafulislam.netlify.app/",
      "sameAs": [
        "https://github.com/ashraful2880",
        "https://www.linkedin.com/in/islam-ashraful1/"
      ],
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Dhaka",
        "addressCountry": "Bangladesh"
      },
      "knowsAbout": ["React", "Next.js", "TypeScript", "Fastify", "PostgreSQL", "Node.js", "AI Integrations", "System Architecture", "Cloud ERP", "Tailwind CSS"]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Security: Comprehensive DevTools Protection
    const protectDevTools = () => {
      // Prevent multiple initializations
      if (window._devToolsProtected) return () => {};
      window._devToolsProtected = true;
      // Disable right-click context menu
      const handleContextMenu = (e) => {
        e.preventDefault();
        return false;
      };

      // Disable developer tools shortcuts
      const handleKeyDown = (e) => {
        // Block F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U, Ctrl+S, Ctrl+A, Ctrl+P
        if (
          e.key === "F12" ||
          (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J" || e.key === "C")) ||
          (e.ctrlKey && (e.key === "u" || e.key === "U")) ||
          (e.ctrlKey && (e.key === "s" || e.key === "S")) ||
          (e.ctrlKey && (e.key === "a" || e.key === "A")) ||
          (e.ctrlKey && (e.key === "p" || e.key === "P")) ||
          (e.key === "F5") ||
          (e.ctrlKey && e.key === "r")
        ) {
          e.preventDefault();
          return false;
        }
      };

      // Disable text selection
      const handleSelectStart = (e) => {
        e.preventDefault();
        return false;
      };

      // Disable drag
      const handleDragStart = (e) => {
        e.preventDefault();
        return false;
      };

      // Add event listeners
      document.addEventListener("contextmenu", handleContextMenu);
      document.addEventListener("keydown", handleKeyDown);
      document.addEventListener("selectstart", handleSelectStart);
      document.addEventListener("dragstart", handleDragStart);

      // Disable console safely (React level)
      const disableConsole = () => {
        // Skip if already protected by HTML level
        if (window._consoleProtected) return;
        
        const noop = () => {};
        const consoleKeys = ['log', 'debug', 'info', 'warn', 'error', 'assert', 'dir', 'dirxml', 'group', 'groupEnd', 'time', 'timeEnd', 'count', 'trace', 'profile', 'profileEnd', 'clear', 'table'];
        
        // Only modify console methods that exist and are configurable
        consoleKeys.forEach(key => {
          try {
            if (console[key] && typeof console[key] === 'function') {
              const descriptor = Object.getOwnPropertyDescriptor(console, key);
              if (!descriptor || descriptor.configurable !== false) {
                console[key] = noop; // Use simple assignment instead of defineProperty
              }
            }
          } catch (e) {
            // Silently fail if we can't redefine this property
          }
        });

        // Mark as protected to avoid conflicts
        window._consoleProtected = true;
      };

      // DevTools detection and blocking
      const detectDevTools = () => {
        const threshold = 160;
        
        const checkDevTools = () => {
          if (
            window.outerHeight - window.innerHeight > threshold ||
            window.outerWidth - window.innerWidth > threshold
          ) {
            // Redirect or close tab when devtools detected
            document.body.innerHTML = `
              <div style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
                background: #000;
                color: #fff;
                font-family: Arial, sans-serif;
                text-align: center;
                flex-direction: column;
              ">
                <h1 style="color: #ff0000; font-size: 48px; margin-bottom: 20px;">🚫 Access Denied</h1>
                <p style="font-size: 24px; margin-bottom: 10px;">Developer tools are not allowed on this website.</p>
                <p style="font-size: 18px; color: #ccc;">Please close developer tools to continue.</p>
                <button onclick="window.location.reload()" style="
                  margin-top: 30px;
                  padding: 15px 30px;
                  background: #22d4fd;
                  color: #000;
                  border: none;
                  border-radius: 5px;
                  font-size: 16px;
                  cursor: pointer;
                  font-weight: bold;
                ">Reload Page</button>
              </div>
            `;
          }
        };

        setInterval(checkDevTools, 500);
      };

      // Additional protection methods
      const additionalProtection = () => {
        // Disable view source
        document.addEventListener('keydown', (e) => {
          if (e.ctrlKey && (e.key === 'u' || e.key === 'U')) {
            e.preventDefault();
            return false;
          }
        });

        // Blur detection (when devtools opens)
        let devtools = { open: false };
        const element = new Image();
        
        Object.defineProperty(element, 'id', {
          get: function() {
            devtools.open = true;
            document.body.innerHTML = `
              <div style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
                background: #000;
                color: #fff;
                font-family: Arial, sans-serif;
                text-align: center;
                flex-direction: column;
              ">
                <h1 style="color: #ff0000; font-size: 48px; margin-bottom: 20px;">🚫 Unauthorized Access</h1>
                <p style="font-size: 24px; margin-bottom: 10px;">This action is not permitted.</p>
                <p style="font-size: 18px; color: #ccc;">Please refresh the page to continue.</p>
              </div>
            `;
            return '';
          }
        });

  

        // Check for devtools periodically
        setInterval(() => {
          if (devtools.open) {
            window.location.reload();
          }
        }, 500);
      };

      // Execute all protection methods
      disableConsole();
      detectDevTools();
      additionalProtection();

      return () => {
        document.removeEventListener("contextmenu", handleContextMenu);
        document.removeEventListener("keydown", handleKeyDown);
        document.removeEventListener("selectstart", handleSelectStart);
        document.removeEventListener("dragstart", handleDragStart);
      };
    };

    // Initialize protection
    const cleanup = protectDevTools();
    
    // Performance: Initialize critical path CSS
    const criticalStyles = `
      .fade-in { opacity: 0; animation: fadeIn 0.6s ease-in-out forwards; }
      @keyframes fadeIn { to { opacity: 1; } }
      .loading-skeleton { background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; }
      @keyframes loading { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
      * { -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; }
      body { -webkit-touch-callout: none; -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; }
    `;
    
    const style = document.createElement('style');
    style.textContent = criticalStyles;
    document.head.appendChild(style);
    
    // Cleanup
    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
      if (style.parentNode) style.parentNode.removeChild(style);
      if (cleanup) cleanup();
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <div className="bg-[#000000] relative z-0">
          <Layout />
          <FairyDustCursor />
          <BackgroundLine />
          <SocialIcon />
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
